import { CwtApiSchema, CwtModel, CwtProp, CwtSchema } from "@cawita/core-front/api";
import { EvaluationResultEntity } from "./eval-result.entity";

@CwtSchema()
export class EvalMentalEye extends CwtApiSchema {
    @CwtProp() complete: number;
    @CwtProp() middle: number;
    @CwtProp() end: number;
}


@CwtSchema()
export class EvalMentalResult extends CwtApiSchema {
    @CwtProp() vmax: number;
    @CwtProp() vmean: number;
    @CwtProp() fatigue: number;
    @CwtProp({ ref: EvalMentalEye}) leftEye: EvalMentalEye;
    @CwtProp({ ref: EvalMentalEye}) rightEye: EvalMentalEye;
}

@CwtModel({ name: 'eval-mental' })
export class EvalMental extends EvaluationResultEntity {
    @CwtProp({ ref: EvalMentalResult }) result: EvalMentalResult;
    @CwtProp() fatigueScore: number;
    @CwtProp() saccadeScore: number;
}